module.exports = __webpack_public_path__ + "img/banner.6fc9346.png";